import React, { useState } from 'react'
import { Modal, Box } from '@mui/material'
import Subscriptions from './Subscription'

interface SubscriptionModalProps {
  isOpen: boolean
  handleClose: () => void
}

const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
  isOpen,
  handleClose,
}: SubscriptionModalProps) => {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <>
        <Box
          sx={(theme) => ({
            background: 'white',
            zIndex: theme.zIndex.drawer + 1,
            position: 'absolute',
            top: '53%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            border: 'none',
            outline: 'none',
            borderRadius: '20px',
            boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.25)',
            padding: '40px 100px',
            height: '70%',
            display: 'flex',
            flexDirection: 'row',
            boxSizing: 'border-box',
          })}
        >
          <Subscriptions />
        </Box>
      </>
    </Modal>
  )
}

export default SubscriptionModal
